import { CrossAppEventData } from "./cross-app-event-data";

/**
 * Represents the detail of a cross app event
 */
export interface CrossAppEventDetail {
  originAppName?: string; // The name of the app that is sending the event
  actionName: string; // The name of the action that is being performed
  data?: CrossAppEventData; // The data that is being sent
}